export const addLeaveManagement = '/leaveManagement';
export const leaveManagement = '/leaveManagement';
export const updateLeaveManagementStatus = '/leaveManagement/updateLeaveStatus/';
export const deleteLeaveManagement = 'leaveManagement/';
export const updateLeaveManagement = '/leaveManagement/updateLeaveManagement/';
